import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';

import { AuthGuard } from '../app/_helpers/auth.guard';
import { environment } from 'src/environments/environment';
import { TenantDetailComponent } from './components/tenant-detail/tenant-detail.component';
const name = environment.envVar.NAME;

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'gateways',
        pathMatch: 'full',
      },
      {
        path: 'gateways',
        loadComponent: () =>
          import('./pages/gateways/gateways.component').then(
            m => m.GatewaysComponent
          ),
        canActivate: [AuthGuard],
        title: `${name} - Gateways`,
      },
      {
        path: 'apps',
        loadComponent: () =>
          import('./pages/tenants/tenants.component').then(
            m => m.TenantsComponent
          ),
        canActivate: [AuthGuard],
        title: `${name} - Apps`,
      },
      {
        path: 'apps/:id',
        component: TenantDetailComponent,
      },
      {
        path: 'devices',
        loadComponent: () =>
          import('./pages/devices/devices.component').then(
            m => m.DevicesComponent
          ),
        canActivate: [AuthGuard],
        title: `${name} - Devices`,
      },
      {
        path: 'not-allowed',
        loadComponent: () =>
          import('./pages/no-permission/no-permission.component').then(
            m => m.PermissionComponent
          ),
        title: `${name} - Not Allowed`,
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./pages/settings/settings.component').then(
            m => m.SettingsComponent
          ),
        canActivate: [AuthGuard],
        title: `${name} - Settings`,
        children: [
          {
            path: 'general',
            loadComponent: () =>
              import('./pages/settings/general/general.component').then(
                m => m.GeneralComponent
              ),
            canActivate: [AuthGuard],
            title: `${name} - General Settings`,
          },
          {
            path: 'users',
            loadComponent: () =>
              import('./pages/users/users.component').then(
                m => m.UsersComponent
              ),
            canActivate: [AuthGuard],
            title: `${name} - Users`,
          },
          {
            path: 'users/:userId',
            loadComponent: () =>
              import('./pages/user-detail/user-detail.component').then(
                m => m.UserDetailComponent
              ),
            canActivate: [AuthGuard],
            title: `${name} - User Details`,
          },
          {
            path: 'integrations',
            loadComponent: () =>
              import(
                './pages/settings/integrations/integrations.component'
              ).then(m => m.IntegrationsComponent),
            canActivate: [AuthGuard],
            title: `${name} - Integrations`,
          },
          {
            path: 'branding',
            loadComponent: () =>
              import('./pages/settings/branding/branding.component').then(
                m => m.BrandingComponent
              ),
            canActivate: [AuthGuard],
            title: `${name} - Branding`,
          },
          {
            path: 'notifications',
            loadComponent: () =>
              import(
                './pages/settings/notifications/notifications.component'
              ).then(m => m.NotificationsComponent),
            canActivate: [AuthGuard],
            title: `${name} - Notifications`,
          },
          {
            path: '',
            redirectTo: 'users',
            pathMatch: 'full',
          },
        ],
      },
    ],
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./layouts/auth-layout/auth-layout.module').then(
            m => m.AuthLayoutModule
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
